import styled from 'styled-components/macro';

// import theme helpers
import { getColor, getFontWeight } from '../../../util/theme';

const BranchListing = styled.div`
  h1 {
    font-weight: ${getFontWeight('medium')};
    text-transform: capitalize;
  }

  ul {
    color: ${getColor('black')};

    display: flex;
    flex-direction: column;

    font-size: 2rem;

    list-style: none;

    margin: 0;
    padding: 0 0 0 2rem;

    li {
      &.fuzzy {
        color: transparent;
        text-shadow: rgba(0, 0, 0, 0.75) 0px 0px 10px;

        a {
          &:hover {
            color: transparent;
          }
        }
      }

      a {
        color: inherit;
        font-weight: ${getFontWeight('light')};
        text-decoration: none;

        display: inline-block;

        padding: 1rem;

        &:hover {
          background-color: ${getColor('accentOrange')};
          color: ${getColor('white')};
        }
      }
    }
  }
`;

export default BranchListing;
